import { render, staticRenderFns } from "./StatusFilters.vue?vue&type=template&id=0c3668ea&scoped=true"
import script from "./StatusFilters.vue?vue&type=script&lang=js"
export * from "./StatusFilters.vue?vue&type=script&lang=js"
import style0 from "./StatusFilters.vue?vue&type=style&index=0&id=0c3668ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3668ea",
  null
  
)

export default component.exports